import { getCategoryBySlug, getCategorySlugByFieldValue } from './category-hub-config';
import type { CategoryDefinition } from '../../types/category-hub';

/**
 * Resolves the active category (if any) from either the route params (SSR / initial render
 * on `/jobs/category/{slug}`) or the current `field` refinement (client-side navigation),
 * mirroring `getLocationFromFiltersAndRoute` in `pages/index/utils/seoUtils.ts`.
 */
export function getCategoryFromFiltersAndRoute(filters: unknown, pageContext: any): CategoryDefinition | null {
  const routeCategorySlug = pageContext?.routeParams?.category;
  if (typeof routeCategorySlug === 'string' && routeCategorySlug.trim()) {
    const bySlug = getCategoryBySlug(routeCategorySlug);
    if (bySlug) return bySlug;
  }

  const parsedFilters =
    filters && typeof filters === 'object'
      ? (filters as any)
      : typeof filters === 'string'
        ? (() => {
            try {
              return JSON.parse(filters || '{}');
            } catch {
              return {};
            }
          })()
        : {};

  const fieldFilters = parsedFilters.field;
  if (Array.isArray(fieldFilters) && fieldFilters.length === 1) {
    const slug = getCategorySlugByFieldValue(fieldFilters[0]);
    if (slug) return getCategoryBySlug(slug);
  }

  return null;
}
